import { useLocation, useNavigate } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'

import PaywallModal from 'modules/core/components/PaywallModal'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import ReportNameModal from 'modules/reports/components/ReportNameModal'
import type { ReportEditorStore } from 'modules/reports/lib/Store'
import type Report from 'modules/reports/store/models/Report'

interface Props {
  report: Report
  store: ReportEditorStore
  onSuccess?: () => void
  clone?: boolean
}

export const SAVE_ACTION = 'save'

function SaveReportModal({ report, store, onSuccess, clone = false }: Props) {
  const {
    company: { subscription },
  } = useCurrentSession()
  const { pathname: currentPath } = useLocation()
  const navigate = useNavigate()

  const inExpiredFreeTrial = subscription.inExpiredFreeTrial

  return inExpiredFreeTrial ? (
    <PaywallModal />
  ) : (
    <Box justifyContent="flexEnd" flexDirection="row" gap="s16">
      <ReportNameModal
        onSuccess={onSuccess}
        report={report}
        store={store}
        onClose={() => {
          navigate(currentPath)
        }}
        clone={clone}
      />
    </Box>
  )
}

export default SaveReportModal
